import type { ReactNode } from "react"

// Search-match highlighting for MultiSelect option labels (flat and tree
// panels). Display-only: cmdk matching / tree filtering are untouched — this
// just wraps every case-insensitive occurrence of the term in a token-styled
// mark so the eye lands on WHY a row matched.
export function highlightLabel(label: string, term: string): ReactNode {
  const needle = term.trim().toLowerCase()
  if (needle === "") return label
  const haystack = label.toLowerCase()
  const parts: ReactNode[] = []
  let cursor = 0
  for (
    let hit = haystack.indexOf(needle);
    hit !== -1;
    hit = haystack.indexOf(needle, cursor)
  ) {
    if (hit > cursor) parts.push(label.slice(cursor, hit))
    parts.push(
      <mark
        key={`${hit}-${needle}`}
        className="rounded-[2px] bg-primary/20 text-inherit"
      >
        {label.slice(hit, hit + needle.length)}
      </mark>,
    )
    cursor = hit + needle.length
  }
  if (parts.length === 0) return label
  if (cursor < label.length) parts.push(label.slice(cursor))
  return <>{parts}</>
}
